module.exports = __webpack_public_path__ + "img/pin_lliege.8c74bfef.png";